const STYlE_CONSTANTS = {
    TEXT_WEIGHT_LIGHT: 200,
    TEXT_WEIGHT_REGULAR: 400,
    TEXT_WEIGHT_BOLD: 700,
}

export default STYlE_CONSTANTS
